// Module
var code = `<form class="login-form">
	<div class="error login-error"></div>
	<div class="input-section w-100">
		<label>Name</label>
		<input type="text" name="username" class="form-control">
	</div>
	<div class="input-section w-100">
		<label>Password</label>
		<input type="password" name="password" class="form-control">
	</div>
	<div class="actions">
		<button class="log-in" type="submit">Login</button>
	</div>
</form>
`;
// Exports
export default code;